import { useState } from "react";
import SelectSearchable from "../SelectSeachble/SelectSearchble";
import Boton from "../UI/Boton";
import { IconoBuscar } from "../UI/Iconos";

// CLIENTES-MODULO-01: filtros del módulo /clientes (búsqueda + estado).
const ESTADOS = [
    { value: "A", label: "Activos" },
    { value: "I", label: "Inactivos" },
    { value: "all", label: "Todos" },
];
const INICIAL = { search: "", estado: "A" };

function PanelFiltrosClientes({ onBuscar, onLimpiar }) {
    const [draft, setDraft] = useState(INICIAL);
    const [estadoOpt, setEstadoOpt] = useState(ESTADOS[0]);

    const buscar = () => onBuscar({ search: draft.search.trim() || "", estado: draft.estado || "A" });
    const limpiar = () => { setDraft(INICIAL); setEstadoOpt(ESTADOS[0]); onLimpiar(); };

    return (
        <div className="card mb-3">
            <div className="card-body py-3">
                <div className="row g-3">
                    <div className="col-12 col-md-6">
                        <label className="kc__etiqueta">Búsqueda</label>
                        <input type="text" className="form-control" placeholder="Nombre o identificación"
                            value={draft.search}
                            onChange={(e) => setDraft({ ...draft, search: e.target.value })}
                            onKeyDown={(e) => e.key === "Enter" && buscar()} />
                    </div>
                    <div className="col-12 col-md-3">
                        <label className="kc__etiqueta">Estado</label>
                        <SelectSearchable
                            listCompany={ESTADOS}
                            handleChange={(o) => { setEstadoOpt(o); setDraft({ ...draft, estado: o?.value ?? "A" }); }}
                            selectedOption={estadoOpt}
                            placeholder="Activos"
                            isClearable={false}
                        />
                    </div>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-3">
                    <Boton onClick={limpiar} data-testid="clientes-limpiar">Limpiar</Boton>
                    {/* Secundario: el primario de la pantalla es "Nuevo cliente". */}
                    <Boton icono={IconoBuscar} onClick={buscar} data-testid="clientes-buscar">Buscar</Boton>
                </div>
            </div>
        </div>
    );
}

export default PanelFiltrosClientes;
